import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  .table {
    thead {
      th {
        vertical-align: middle;
        border-bottom-width: 1px;
        text-transform: capitalize;
        color: #3ee9f7;
        font-style: normal;
        font-weight: 500;
        border-top: none;

        i {
          display: none;
        }
      }
    }

    tbody {
      tr {
        td:nth-of-type(2) {
          color: #ff0033;
        }

        .yellow {
          color: #b5f92d;
        }

        .red {
          color: #ff0033;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CourseTracker/CourseTracker.styles.ts